module.exports = __webpack_public_path__ + "img/caiWu.8863b786.svg";